<!--<div  *ngIf="!initialLoaing; else loading" >-->

<div class="wrapper"  *ngIf="stream" > 
    <h5>Ретрансляції</h5>



    <div class="head">
        <div style="width: 20px;"></div>
        <div>RTMP URL</div>
        <div   >RTMP ключ</div>
        <div  style="display:none" class="toggle">Вимк/Увімк</div>
        <div style="display:none">Логін</div>
        <div style="display:none">Пароль</div>
    </div>


    <div>

 
        <div class="restreamsItems scrollable-container">

        <div *ngFor="let restream of restreams; let i = index" class="item">
           
            <div  style="display:flex; width: 20px;">
                <span style="margin:auto;">{{i+1}}.</span>
            </div>
           
           <div>
               <input [(ngModel)]="restream.url" nbInput type="text" />
               <div class="text-danger" *ngIf="restream.errorUrl">{{restream.errorUrl}}</div>
           </div> 

            
            
           <div >
            <input nbInput [(ngModel)]="restream.key" type="text" />
            <div class="text-danger" *ngIf="restream.errorKey">{{restream.errorKey}}</div>

        </div> 

        <div  style="display:none" class="toggle">
            <nb-toggle  [(checked)]="restream.active" status="primary"></nb-toggle>

        </div>

         
           
        <div style="display:none">
            <input nbInput [(ngModel)]="restream.login" type="text" />
            <div class="text-danger" *ngIf="restream.errorLogin">{{restream.errorLogin}}</div>

        </div> 

         
           
        <div style="display:none">
            <input nbInput [(ngModel)]="restream.password" type="text" />
            <div class="text-danger" *ngIf="restream.errorPassword">{{restream.errorPassword}}</div>

        </div> 


        </div>
    </div>


        <div style="display: flex;">
            <div style="display: flex; margin-left: auto; 
            margin-right: 10px; margin-top: 15px;">
 
           <button nbButton (click)="save()" status="success">Зберегти </button>

            </div>
        </div>

    </div>
 


    <div *ngIf="loading" style="position: absolute; z-index: 777; background-color:rgba(0,0,0,0.5); width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;"> 
             <app-loader></app-loader>
         </div>
        </div>


</div> 
     



